export default function LogoIcon({ className = "h-8" }) {
  return (
    <img
      src="/advaltis-icon.png"
      alt="Advaltis"
      className={`${className} object-contain`}
    />
  );
}
